import React, { FC, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { PageTabsNames } from '../../../constants/PageTabsNames';
import { useTrackTabClick } from '../../../utils/hooks/bi/useTrackTabClick';
import { Tabs } from '../wixCommon';
import { IOuter } from './PageTabs.types';

export const PageTabs: FC<IOuter> = ({ activeTab, onClick }) => {
  const { formatMessage } = useIntl();
  const { trackTabClick } = useTrackTabClick();

  const handleTabClick = useCallback(
    ({ id }) => {
      onClick({ id });
      trackTabClick({ target: id });
    },
    [onClick, activeTab, trackTabClick],
  );

  return (
    <Tabs
      dataHook="home-tabs"
      activeId={activeTab}
      onClick={handleTabClick}
      items={[
        {
          id: PageTabsNames.Templates,
          title: formatMessage({
            id: 'video-maker-home.main.header.tab.templates',
          }),
        },
        {
          id: PageTabsNames.MyVideos,
          title: formatMessage({
            id: 'video-maker-home.main.header.tab.my-videos',
          }),
        },
      ]}
    />
  );
};
